export default __webpack_public_path__ + "static/X06-52914854ba49eb301d8262cda2f300b5.png";